<template>
    <grid
        controllers='true' 
        :titles='titles'
        :data='contents'
        current-sort="id"
        search-key="NOME"
    />
</template>
<script>
    import grid from '@/components/grid.vue'
    export default {
        name: 'vwClients',
        components: {
            grid
        },
        data(){
            return{
                titles: ['Nome', 'Razão Social', 'Cadastrado', 'Telefone', 'Email'],
                contents: []
            }
        },
        computed: {
            getToken(){
                return this.$store.getters.getToken
            }
        },
        methods: {
            getData: function(){
                fetch(server + 'grides/clientes', {
                    method: 'GET',
                    headers: new Headers({
                        'token' : this.getToken
                    })
                })
                    .then(response => (response.json()))
                    .then(responseJSON => {
                        if(responseJSON.data == true){
                            this.contents = responseJSON.response
                        }
                    })
                    .catch(error => {
                        console.log('Error exception', '=>', error)
                    })
            }
        },
        mounted(){
            this.getData()
        }
    }
</script>
<style scoped>

</style>